import { render, staticRenderFns } from "./BonusItem.vue?vue&type=template&id=14792699&"
import script from "./BonusItem.vue?vue&type=script&lang=js&"
export * from "./BonusItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports